var React = require('react');

function ShieldInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 20.846c.206 31.977 28.402 50.36 28.402 50.36S58.804 52.101 58.6 20.494c0 0-19.9-9.987-28.197-18.494C22.928 9.805 2 20.846 2 20.846Z","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"m18.593 36.437 9.137 10.856 16.985-20.159","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":1})]);
}

ShieldInline.defaultProps = {"width":"60","height":"73","fill":"none"};

module.exports = ShieldInline;

ShieldInline.default = ShieldInline;
